import { AccordionList } from "../../../../modules/content/components/AccordionList/AccordionList";
import { WohaCommonContent } from "../../../../modules/content/components/WohaCommonContent/WohaCommonContent";
import { WohaSection } from "../../../../modules/content/components/WohaSection/WohaSection";
import type { IAccordionBlockProps } from "./AccordionBlock.props";
export const AccordionBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  items,
  openBehavior,
  parentClass,
  spacing,
}: IAccordionBlockProps) => {
  if (!items?.length) return null;
  return (
    <WohaSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-10">
        <WohaCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <AccordionList items={items} openBehavior={openBehavior} />
      </div>
    </WohaSection>
  );
};
AccordionBlock.displayName = "Block::AccordionBlock";
